import Agent from './agent'

const agent = new Agent()

export const unitConversionService = {
  get: () => agent.get(`/unit-conversion`),
  update: (data) => agent.post(`/unit-conversion`, { data }),
}
